import React from 'react';
import Images from '../assets/AllImages';
import { useTranslation } from 'react-i18next';

const mainData = (t) => [
  [
    {
      img: Images.EVENTS1,
      title: t("events.card1.title"),
      desc: t("events.card1.desc"),
    },
    {
      img: Images.EVENTS1,
      title: t("events.card2.title"),
      desc: t("events.card2.desc"),
    },
    // more cards if needed
  ],
];

const EVENTSCARDS = ({ img, title, desc }) => {
  return (
    <div className="w-100 p-2">
      <div
        className="h-100 shadow-sm"
        style={{
          borderRadius: '16px',
          overflow: 'hidden',
          transition: 'all 0.3s ease',
          border: 'none',
          cursor: 'default',
          backgroundColor: '#fff',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.border = '2px solid #007bff';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.border = 'none';
        }}
      >
        <img
          src={img}
          alt={title}
          className="w-100"
          style={{ height: '300px', objectFit: 'cover' }}
        />
        <div className="p-4 text-md-center">
          <h4 className="text-primary fw-bold mb-3" style={{ fontSize: '1.6rem' }}>{title}</h4>
          <p style={{ fontSize: '1.2rem' }}>{desc}</p>
          <span className="text-muted" style={{ fontSize: '0.85rem' }}>17.06.2025</span>
        </div>
      </div>
    </div>
  );
};

const EVENTS = () => {
  const { t } = useTranslation();

  return (
    <>
      <main>
        <div className="container-fluid bg-primary py-3 py-md-0">
          <div className="row align-items-center">
            <div className="col-12 col-md-6 px-5">
              <h1 className="text-white fw-bold mb-4 responsive-heading">{t("events.title")}</h1>
            </div>
            <div className="col-12 col-md-6 px-5 d-none d-sm-block">
              <img src={Images.Vactor2} alt="" className="w-50 float-end" />
            </div>
          </div>
        </div>
      </main>

      <div className="w-100 px-3 my-4">
        {mainData(t).map((group, idx) => (
          <div className="row g-3 mb-4" key={idx}>
            {group.map((item, i) => (
              <div className="col-12 col-md-4" key={i}>
                <EVENTSCARDS {...item} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default EVENTS;
